<template>
  <li class="c-entrepneur-vertical-name-item-list">
    <!-- first name -->
    <h1 class="c-entrepneur-vertical-name-item__title | t-t1-heavy">
      <span>{{ firstName }}</span>
      <!-- arrow -->
      <icon class="c-entrepneur-vertical-name-item__title__icon" icon="arrow-right" />
      <!-- last name -->
      <span>{{ lastName }}</span>
      <!-- end of the name -->
      <icon class="c-entrepneur-vertical-name-item__title__icon" icon="arrow-right" />
    </h1>
  </li>
</template>

<script>
import Icon from "objects/Icon";
export default {
  components: {
    Icon
  },
  props: {
    firstName: {
      type: String,
      required: true
    },
    lastName: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.c-entrepneur-vertical-name-item {
  &__title {
    @include outLinedTitle($color-bright);
    display: flex;
    align-content: center;
    align-items: center;
    flex-direction: row;
    span {
      white-space: nowrap;
    }
    &__icon {
      padding: 0px var(--grid-gutter);
      &::v-deep svg {
        fill: $color-bright;
        max-height: 30px;
        @media #{$breakpoint-horizontal} {
          max-height: 70px;
        }
      }
    }
  }
}
</style>
